export default __webpack_public_path__ + "static/media/banner-img-one.2c760630.png";